import type { Grid2Props as GridProps } from '@mui/material';
import { Grid2 as MaterialGrid } from '@mui/material';
import React from 'react';
import { BREAKPOINT } from '../../utils/breakpoints';
import {
  getAvailableColumnsCount,
  GRID_CONFIGS_FOR_BREAKPOINTS,
} from '../../utils/gridHelper';

interface IGridContainer {
  /** This is for supporting a component that sometimes
  is its own page, but sometimes is embedded.
  E.g. the calculator, it's alwaysSingleColumn=true
  when embedded in the enrollment page, otherwise
  has a normal grid layout.
   */
  alwaysSingleColumn?: boolean;
}

/**
 * FYI, this component uses negative margins so it will look a little
 * weird/misaligned in the inspect element screen even if it is aligned correctly.
 */
const GridContainer: React.FC<
IGridContainer & Omit<GridProps, 'container' | 'xs'>
> = ({ alwaysSingleColumn = false, ...props }) => (
  <MaterialGrid
    spacing={{
      desktop: GRID_CONFIGS_FOR_BREAKPOINTS[BREAKPOINT.DESKTOP].spacing,
      tablet: GRID_CONFIGS_FOR_BREAKPOINTS[BREAKPOINT.TABLET].spacing,
      tabletMini: GRID_CONFIGS_FOR_BREAKPOINTS[BREAKPOINT.TABLET_MINI].spacing,
      mobile: GRID_CONFIGS_FOR_BREAKPOINTS[BREAKPOINT.MOBILE].spacing,
    }}
    columns={{
      // https://www.figma.com/file/pv2HV6DTSKY612VWeYWYdL/CE22-Design-System?node-id=1867%3A4335
      // Special case! The outermost 2 columns of desktop are not used.
      desktop: alwaysSingleColumn
        ? 1
        : getAvailableColumnsCount(
          GRID_CONFIGS_FOR_BREAKPOINTS[BREAKPOINT.DESKTOP],
        ),
      tablet: alwaysSingleColumn
        ? 1
        : getAvailableColumnsCount(
          GRID_CONFIGS_FOR_BREAKPOINTS[BREAKPOINT.TABLET],
        ),
      tabletMini: alwaysSingleColumn
        ? 1
        : getAvailableColumnsCount(
          GRID_CONFIGS_FOR_BREAKPOINTS[BREAKPOINT.TABLET_MINI],
        ),
      mobile: alwaysSingleColumn
        ? 1
        : getAvailableColumnsCount(
          GRID_CONFIGS_FOR_BREAKPOINTS[BREAKPOINT.MOBILE],
        ),
    }}
    container
    sx={{ width: '100%' }}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  />
);

export default GridContainer;
